
import React, {useState, useEffect, useContext,useRef} from "react";
import {useHistory} from "react-router-dom";
import classNames from "classnames";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  Button,
} from "reactstrap";

import {
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import ReactTable from "components/ReactTable/ReactTable.js";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationAlert from "react-notification-alert";
import rest from "../../API/api";
import { UserLoginContext } from "../../context/UserLoginContext";
import { CollectionsContext } from "../../context/CollectionsContext";
import { authenticatedFetch } from "../../services/authService";

const TourneyCollectionsTable = () => {
    const [collectionsState, setCollectionsState] = useContext(CollectionsContext);
    const [userState, setUserState] = useContext(UserLoginContext);
    const [alert, setalert] = React.useState(null);
    const notificationAlertRef = useRef(null);
    const history = useHistory();
    const [data, setData] = React.useState([]);

    // Update table data whenever tourney collections change
    useEffect(() => {
        if (userState.status && collectionsState.tourneyCollections && Array.isArray(collectionsState.tourneyCollections)) {
            const tableData = collectionsState.tourneyCollections.map((theCollection, i) => {
                return {
                    id: theCollection._id,
                    Title: theCollection.Title,
                    Description: theCollection.Description,

                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Collection</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            tourneyCollection: theCollection}));
                                        let tURL = "/admin/edittourneycollection/";
                                        await history.push(tURL);
                                    }}
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-pencil"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to remove the data row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"delete_" + i}>Delete Collection</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        const collectionIndex = collectionsState.tourneyCollections.findIndex(c => c._id === theCollection._id);
                                        if (collectionIndex !== -1) {
                                            _deleteCollectionAlert(theCollection._id, collectionsState.tourneyCollections, collectionIndex);
                                        }
                                    }}
                                    color="danger"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-simple-remove"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to Add Collection Images the collection on this row */}
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"addimage_" + i}>Add a Collection Image</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        //Set the current collection state for use in /admin/addtourneyimage/
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            tourneyCollection: theCollection
                                        }));
                                        //Call /admin/addcohortimage/:collectionId route and use this state to add an image to this collection
                                        //Lets load all the images for this collection into the context
                                        let tempURL = rest.tourneyImages + '/' + theCollection._id;
                                        const tourneyImagesList = await authenticatedFetch(tempURL, {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            }
                                        });
                                        const tourneyImagesData = await tourneyImagesList.json();
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            tourneyImages: tourneyImagesData
                                        }));
                                        //Call /admin/addtourneyimage/:collectionId route and use this state to add an image to this collection
                                        let tURL = "/admin/addtourneyimage/" + theCollection._id + "?from=collections";
                                        await history.push(tURL);
                                    }}
                                    color="info"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-image-02"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            <OverlayTrigger placement="top"
                                            overlay={<Tooltip id={"editimage_" + i}>Edit Collection Images</Tooltip>}>
                                <span>
                                <Button
                                    onClick={async () => {
                                        //Set the current collection state for use in /admin/edittourneyimages/
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            tourneyCollection: theCollection
                                        }));
                                        //Call /admin/edittourneyimages/ route and use this state to add an image to this collection
                                        //Lets load all the images for this collection into the context
                                        let tempURL = rest.tourneyImages + '/' + theCollection._id;
                                        const tourneyImagesList = await authenticatedFetch(tempURL, {
                                            method: 'GET',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            }
                                        });
                                        const tourneyImagesData = await tourneyImagesList.json();
                                        setCollectionsState((prevcollectionsState) => ({
                                            ...prevcollectionsState,
                                            tourneyImages: tourneyImagesData
                                        }));
                                        let tURL = "/admin/edittourneyimages/" + theCollection._id;
                                        await history.push(tURL);
                                    }
                                }
                                    color="warning"
                                    size="sm"
                                    className={classNames("btn-icon btn-link like",)}
                                >
                                    <i className="tim-icons icon-vector"/>
                                </Button>{" "}
                                </span>
                            </OverlayTrigger>

                        </div>
                    )
                };
            });
            setData(tableData);
        }
    }, [collectionsState.tourneyCollections, userState.status]);

    const notify = (type, message) => {
        const options = {
            place: "tc",
            message: <div>{message}</div>,
            type: type,
            icon: "tim-icons icon-bell-55",
            autoDismiss: 5,
        };
        notificationAlertRef.current.notificationAlert(options);
    };

    useEffect(() => {
        const getCollections = async () => {
            const tourneyCollectionsList = await authenticatedFetch(rest.tourneyCollections, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const tourneyCollectionsData = await tourneyCollectionsList.json();
            setCollectionsState((collectionsState) => ({
                ...collectionsState,
                tourneyCollections: tourneyCollectionsData
            }));
        };
        getCollections(); // run it, run it
    }, []);

    const _delete_collection = async (id) => {
        let tempURL = rest.tourneyCollections + '/' + id;
        const collectionsList = authenticatedFetch(tempURL, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const collectionsResponse = await collectionsList;
        const collectionsData = await collectionsResponse.json();
        return collectionsData;
    };

    const _deleteCollectionAlert = async (id,collections,index) => {
        //console.log("email to delete:" + email);
        //debugger;
        let tempURL = rest.tourneyImages + '/' + id;
        const tourneyImagesList = await authenticatedFetch(tempURL, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const tourneyImagesData = await tourneyImagesList.json();
        if(tourneyImagesData.length === 0) {
            setalert(
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    style={{display: "block"}}
                    onConfirm={async () => {
                        try {
                            await _delete_collection(id);

                            // Re-fetch collections to refresh the table
                            const response = await authenticatedFetch(rest.tourneyCollections, {
                                method: 'GET',
                                headers: {
                                    'Content-Type': 'application/json'
                                }
                            });
                            const tourneyCollectionsData = await response.json();
                            setCollectionsState((prevcollectionsState) => ({
                                ...prevcollectionsState,
                                tourneyCollections: tourneyCollectionsData
                            }));

                            setalert(null);
                            notify("success", "Collection has been deleted successfully!");
                        } catch (error) {
                            setalert(null);
                        }
                    }}
                    onCancel={() => {
                        setalert(null);
                    }}
                >
                    Are you sure you want to delete this collection?
                </SweetAlert>
            );
        }
        else {
            setalert(
                <SweetAlert
                    danger
                    confirmBtnText="Ok"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Collection is not empty!"
                    style={{display: "block"}}
                    onConfirm={() => {
                        setalert(null);
                    }}
                    onCancel={() => {
                        setalert(null);
                    }}
                >
                    Please delete all child images for this collection!
                </SweetAlert>
            );
            return (tourneyImagesData);
        }
    };
    if (userState.status) {
        /*
        console.log("Cohort Collections State:");
        console.log(collectionsState.cohortCollections);
        console.log("Tourney Collections State:");
        console.log(collectionsState.tourneyCollections);
        console.log("General Collections State:");
        console.log(collectionsState.generalCollections);
        */
        return (
            <>
                <div className="rna-container">
                    <NotificationAlert ref={notificationAlertRef} />
                </div>
                <div className="content">
                    <Col md={8} className="ml-auto mr-auto">
                        <h2 className="text-center">Tourney Image Gallery</h2>
                        <p className="text-center">
                            This is a list tourney images organized into collections
                        </p>
                    </Col>
                    <Row className="mt-5">
                        <Col xs={12} md={12}>
                            <Card>
                                <CardHeader>
                                    <Row>
                                        <Col md="6">
                                            <CardTitle tag="h4">Tourney Image Collections</CardTitle>
                                        </Col>
                                        <Col md="6" className="text-right">
                                            <Button
                                                color="info"
                                                onClick={() => history.push("/admin/addtourneycollection")}
                                                className="animation-on-hover"
                                            >
                                                <i className="tim-icons icon-simple-add"/> Add Collection
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                <CardBody>
                                    <ReactTable
                                        data={data}
                                        filterable
                                        columns={[
                                            {
                                                Header: "Title",
                                                accessor: "Title"
                                            },
                                            {
                                                Header: "Description",
                                                accessor: "Description"
                                            },
                                            {
                                                Header: "Actions",
                                                accessor: "actions",
                                                sortable: false,
                                                filterable: false
                                            }
                                        ]}
                                        defaultPageSize={5}
                                        showPaginationTop
                                        showPaginationBottom={false}
                                        className="-striped -highlight"
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {alert}
                </div>
            </>

        );
    }

    else {
        //alert("You must be logged in and have an active subscription to access this page!");
        history.push("/admin/dashboard");
        return(null);
    }
};

export default TourneyCollectionsTable;
